export const STATUS = [
  { value: 'live', label: 'Live' },
  { value: 'unknown', label: 'Unknown' },
  { value: 'dnq', label: 'DNQ' },
  { value: 'deceased', label: 'Deceased' },
  { value: 'gdpr', label: 'GDPR' },
  { value: 'retired', label: 'Retired' },
  { value: 'onleave', label: 'OnLeave' }
]

export const FUNCTIONS = [
  { label: 'President', value: 'President' },
  { label: 'Chairman', value: 'Chairman' },
  { label: 'Chief Executive Officer', value: 'Chief Executive Officer' },
  { label: 'Chief Operating Officer', value: 'Chief Operating Officer' },
  { label: 'Director of Finance/CFO', value: 'Director of Finance/CFO' },
  { label: 'Director/Board Member', value: 'Director/Board Member' },
  { label: 'Founder', value: 'Founder' },
  { label: 'Chief Investment Officer', value: 'Chief Investment Officer' },
  { label: 'Director of Research - Equity', value: 'Director of Research - Equity' },
  { label: 'Director of Research - Fixed Income', value: 'Director of Research - Fixed Income' },
  { label: 'Portfolio Manager-Equities', value: 'Portfolio Manager-Equities' },
  { label: 'Portfolio Manager-Fixed Income', value: 'Portfolio Manager-Fixed Income' },
  { label: 'Associate Portfolio Manager-Equity', value: 'Associate Portfolio Manager-Equity' },
  { label: 'Associate Portfolio Manager-Fixed Income', value: 'Associate Portfolio Manager-Fixed Income' },
  { label: 'Analyst-Equity', value: 'Analyst-Equity' },
  { label: 'Analyst-Fixed Income', value: 'Analyst-Fixed Income' },
  { label: 'Research Associate-Equity', value: 'Research Associate-Equity' },
  { label: 'Research Associate-Fixed Income', value: 'Research Associate-Fixed Income' },
  { label: 'Head of Buy-Side Corporate Access', value: 'Head of Buy-Side Corporate Access' },
  { label: 'Buy-Side Corporate Access', value: 'Buy-Side Corporate Access' },
  { label: 'ICL Contact', value: 'ICL Contact' },
  { label: 'Admin', value: 'Admin' },
  { label: 'Media Relations', value: 'Media Relations' },
  { label: 'Internal Contact', value: 'Internal Contact' },
  { label: 'Product Specialist', value: 'Product Specialist' },
  { label: 'Strategist', value: 'Strategist' },
  { label: 'Economist', value: 'Economist' },
  { label: 'Head of Trading', value: 'Head of Trading' },
  { label: 'Trader', value: 'Trader' },
  { label: 'Asset Allocator', value: 'Asset Allocator' },
  { label: 'Sales', value: 'Sales' },
  { label: 'Investment Banking', value: 'Investment Banking' },
  { label: 'Investment Committee Member', value: 'Investment Committee Member' },
  { label: 'Corporate Officer/Principal', value: 'Corporate Officer/Principal' },
  { label: 'Head-Equity Investments', value: 'Head-Equity Investments' },
  { label: 'Private Equity Investor', value: 'Private Equity Investor' },
  { label: 'Market Strategist', value: 'Market Strategist' },
  { label: 'Executive', value: 'Executive' }
]

export const SECTOR = [
  { value: 'Non-Energy Minerals', label: 'Non-Energy Minerals' },
  { value: 'Producer Manufacturing', label: 'Producer Manufacturing' },
  { value: 'Electronic Technology', label: 'Electronic Technology' },
  { value: 'Consumer Durables', label: 'Consumer Durables' },
  { value: 'Energy Minerals', label: 'Energy Minerals' },
  { value: 'Process Industries', label: 'Process Industries' },
  { value: 'Health Technology', label: 'Health Technology' },
  { value: 'Consumer Non-Durables', label: 'Consumer Non-Durables' },
  { value: 'Industrial Services', label: 'Industrial Services' },
  { value: 'Commercial Services', label: 'Commercial Services' },
  { value: 'Distribution Services', label: 'Distribution Services' },
  { value: 'Technology Services', label: 'Technology Services' },
  { value: 'Health Services', label: 'Health Services' },
  { value: 'Consumer Services', label: 'Consumer Services' },
  { value: 'Retail Trade', label: 'Retail Trade' },
  { value: 'Transportation', label: 'Transportation' },
  { value: 'Utilities', label: 'Utilities' },
  { value: 'Finance', label: 'Finance' },
  { value: 'Communications', label: 'Communications' },
  { value: 'Miscellaneous', label: 'Miscellaneous' },
  { value: 'Government', label: 'Government' },
  { value: 'Not Classified', label: 'Not Classified' }
]

export const SECURITYTYPE = [
  { value: 'Common Stock', label: 'Common Stock' },
  { value: 'Preferred Stock', label: 'Preferred Stock' },
  { value: 'MLP', label: 'MLP' },
  { value: 'Convertible Stocks', label: 'Convertible Stocks' },
  { value: 'Corporate Bond', label: 'Corporate Bond' },
  { value: 'Convertible Bonds', label: 'Convertible Bonds' },
  { value: 'Green Bonds', label: 'Green Bonds' },
  { value: 'ABS', label: 'ABS' },
  { value: 'MBS', label: 'MBS' },
  { value: 'Money Market', label: 'Money Market' }
]

export const STYLE = [
  { value: 'Growth', label: 'Growth' },
  { value: 'Value', label: 'Value' },
  { value: 'GARP', label: 'GARP' },
  { value: 'Blend', label: 'Blend' },
  { value: 'Contrarian', label: 'Contrarian' }
]

export const MARKETCAP = [
  { value: 'Micro-Cap', label: 'Micro-Cap' },
  { value: 'Small-Cap', label: 'Small-Cap' },
  { value: 'Mid-Cap', label: 'Mid-Cap' },
  { value: 'Large-Cap', label: 'Large-Cap' },
  { value: 'Mega-Cap', label: 'Mega-Cap' }
]

export const QUALITY = [
  { value: 'Investment Grade', label: 'Investment Grade' },
  { value: 'High Yield', label: 'High Yield' },
  { value: 'Distressed', label: 'Distressed' },
  { value: 'Default', label: 'Default' }
]

export const STRATEGY = [
  { value: 'Long/Short', label: 'Long/Short' },
  { value: 'Short', label: 'Short' },
  { value: 'Quantitative', label: 'Quantitative' },
  { value: 'Socially Responsible', label: 'Socially Responsible' },
  { value: 'Distressed', label: 'Distressed' },
  { value: 'Momentum', label: 'Momentum' },
  { value: 'Yield', label: 'Yield' },
  { value: 'Special Situations', label: 'Special Situations' },
  { value: 'Behavioral', label: 'Behavioral' },
  { value: 'Technical', label: 'Technical' },
  { value: 'Blend', label: 'Blend' },
  { value: 'Long-Only', label: 'Long-Only' },
  { value: 'Long-Biased', label: 'Long-Biased' },
  { value: 'Corporate Access', label: 'Corporate Access' }
]

export const REGION = [
  { value: 'Africa', label: 'Africa' },
  { value: 'Asia', label: 'Asia' },
  { value: 'Caribbean', label: 'Caribbean' },
  { value: 'Central America', label: 'Central America' },
  { value: 'Europe', label: 'Europe' },
  { value: 'Middle East', label: 'Middle East' },
  { value: 'North America', label: 'North America' },
  { value: 'Oceania', label: 'Oceania' },
  { value: 'South America', label: 'South America' }
]

export const CUSTOM_REGION = [
  { value: 'EU', label: 'EU' },
  { value: 'APAC', label: 'APAC' },
  { value: 'ASEAN', label: 'ASEAN' },
  { value: 'APEC', label: 'APEC' },
  { value: 'Baltics', label: 'Baltics' },
  { value: 'Benelux', label: 'Benelux' },
  { value: 'BRICS', label: 'BRICS' },
  { value: 'CEE', label: 'CEE' },
  { value: 'CEEMEA', label: 'CEEMEA' },
  { value: 'CIS', label: 'CIS' },
  { value: 'Developed Markets', label: 'Developed Markets' },
  { value: 'EMEA', label: 'EMEA' },
  { value: 'EAFE', label: 'EAFE' },
  { value: 'Emerging Markets', label: 'Emerging Markets' },
  { value: 'Eurozone', label: 'Eurozone' },
  { value: 'Frontier Markets', label: 'Frontier Markets' },
  { value: 'G20', label: 'G20' },
  { value: 'G10', label: 'G10' },
  { value: 'G5', label: 'G5' },
  { value: 'G7', label: 'G7' },
  { value: 'Greater China', label: 'Greater China' },
  { value: 'LATAM', label: 'LATAM' },
  { value: 'MENA', label: 'MENA' },
  { value: 'NAFTA', label: 'NAFTA' },
  { value: 'Nordic', label: 'Nordic' },
  { value: 'OCED', label: 'OCED' },
  { value: 'OPEC', label: 'OPEC' },
  { value: 'Pacific Rim', label: 'Pacific Rim' },
  { value: 'Scandinavia', label: 'Scandinavia' },
  { value: 'South Asia', label: 'South Asia' },
  { value: 'TPP', label: 'TPP' },
  { value: 'Western Europe', label: 'Western Europe' },
  { value: 'Global (ex-USA)', label: 'Global (ex-USA)' }
]

export const COUNTRY = [
  { value: 'Afghanistan', label: 'Afghanistan' },
  { value: 'Albania', label: 'Albania' },
  { value: 'Algeria', label: 'Algeria' },
  { value: 'Angola', label: 'Angola' },
  { value: 'Argentina', label: 'Argentina' },
  { value: 'Armenia', label: 'Armenia' },
  { value: 'Aruba', label: 'Aruba' },
  { value: 'Australia', label: 'Australia' },
  { value: 'Austria', label: 'Austria' },
  { value: 'Azerbaijan', label: 'Azerbaijan' },
  { value: 'Bahamas', label: 'Bahamas' },
  { value: 'Bahrain', label: 'Bahrain' },
  { value: 'Bangladesh', label: 'Bangladesh' },
  { value: 'Barbados', label: 'Barbados' },
  { value: 'Belarus', label: 'Belarus' },
  { value: 'Belgium', label: 'Belgium' },
  { value: 'Belize', label: 'Belize' },
  { value: 'Benin', label: 'Benin' },
  { value: 'Bhutan', label: 'Bhutan' },
  { value: 'Bolivia', label: 'Bolivia' },
  { value: 'Bosnia anderzegovina', label: 'Bosnia anderzegovina' },
  { value: 'Botswana', label: 'Botswana' },
  { value: 'Brazil', label: 'Brazil' },
  { value: 'Brunei Darussalam', label: 'Brunei Darussalam' },
  { value: 'Bulgaria', label: 'Bulgaria' },
  { value: 'Burkina Faso', label: 'Burkina Faso' },
  { value: 'Burundi', label: 'Burundi' },
  { value: 'Cambodia', label: 'Cambodia' },
  { value: 'Cameroon', label: 'Cameroon' },
  { value: 'Canada', label: 'Canada' },
  { value: 'Cape Verde', label: 'Cape Verde' },
  { value: 'Cayman Islands', label: 'Cayman Islands' },
  { value: 'Central African Republic', label: 'Central African Republic' },
  { value: 'Chad', label: 'Chad' },
  { value: 'Channel Islands', label: 'Channel Islands' },
  { value: 'Chile', label: 'Chile' },
  { value: 'China', label: 'China' },
  { value: 'Colombia', label: 'Colombia' },
  { value: 'Comoros', label: 'Comoros' },
  { value: 'Congo', label: 'Congo' },
  { value: 'Costa Rica', label: 'Costa Rica' },
  { value: 'Côte d\'Ivoire', label: 'Côte d\'Ivoire' },
  { value: 'Croatia', label: 'Croatia' },
  { value: 'Cuba', label: 'Cuba' },
  { value: 'Cyprus', label: 'Cyprus' },
  { value: 'Czech Republic', label: 'Czech Republic' },
  { value: 'Democratic Republic of the Congo', label: 'Democratic Republic of the Congo' },
  { value: 'Denmark', label: 'Denmark' },
  { value: 'Djibouti', label: 'Djibouti' },
  { value: 'Dominican Republic', label: 'Dominican Republic' },
  { value: 'Ecuador', label: 'Ecuador' },
  { value: 'Egypt', label: 'Egypt' },
  { value: 'El Salvador', label: 'El Salvador' },
  { value: 'Equatorial Guinea', label: 'Equatorial Guinea' },
  { value: 'Eritrea', label: 'Eritrea' },
  { value: 'Estonia', label: 'Estonia' },
  { value: 'Ethiopia', label: 'Ethiopia' },
  { value: 'Fiji', label: 'Fiji' },
  { value: 'Finland', label: 'Finland' },
  { value: 'France', label: 'France' },
  { value: 'French Guiana', label: 'French Guiana' },
  { value: 'French Polynesia', label: 'French Polynesia' },
  { value: 'Gabon', label: 'Gabon' },
  { value: 'Gambia', label: 'Gambia' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Germany', label: 'Germany' },
  { value: 'Ghana', label: 'Ghana' },
  { value: 'Greece', label: 'Greece' },
  { value: 'Grenada', label: 'Grenada' },
  { value: 'Guadeloupe', label: 'Guadeloupe' },
  { value: 'Guam', label: 'Guam' },
  { value: 'Guatemala', label: 'Guatemala' },
  { value: 'Guinea', label: 'Guinea' },
  { value: 'Guinea-Bissau', label: 'Guinea-Bissau' },
  { value: 'Guyana', label: 'Guyana' },
  { value: 'Haiti', label: 'Haiti' },
  { value: 'Honduras', label: 'Honduras' },
  { value: 'Hong Kong', label: 'Hong Kong' },
  { value: 'Hungary', label: 'Hungary' },
  { value: 'Iceland', label: 'Iceland' },
  { value: 'India', label: 'India' },
  { value: 'Indonesia', label: 'Indonesia' },
  { value: 'Iran', label: 'Iran' },
  { value: 'Iraq', label: 'Iraq' },
  { value: 'Ireland', label: 'Ireland' },
  { value: 'Israel', label: 'Israel' },
  { value: 'Italy', label: 'Italy' },
  { value: 'Jamaica', label: 'Jamaica' },
  { value: 'Japan', label: 'Japan' },
  { value: 'Jordan', label: 'Jordan' },
  { value: 'Kazakhstan', label: 'Kazakhstan' },
  { value: 'Kenya', label: 'Kenya' },
  { value: 'Kuwait', label: 'Kuwait' },
  { value: 'Kyrgyzstan', label: 'Kyrgyzstan' },
  { value: 'Laso', label: 'Laso' },
  { value: 'Latvia', label: 'Latvia' },
  { value: 'Lebanon', label: 'Lebanon' },
  { value: 'Lesotho', label: 'Lesotho' },
  { value: 'Liberia', label: 'Liberia' },
  { value: 'Libya', label: 'Libya' },
  { value: 'Lithuania', label: 'Lithuania' },
  { value: 'Luxembourg', label: 'Luxembourg' },
  { value: 'Maco', label: 'Maco' },
  { value: 'Madagascar', label: 'Madagascar' },
  { value: 'Malawi', label: 'Malawi' },
  { value: 'Malaysia', label: 'Malaysia' },
  { value: 'Maldives', label: 'Maldives' },
  { value: 'Mali', label: 'Mali' },
  { value: 'Malta', label: 'Malta' },
  { value: 'Martinique', label: 'Martinique' },
  { value: 'Mauritania', label: 'Mauritania' },
  { value: 'Mauritius', label: 'Mauritius' },
  { value: 'Mayotte', label: 'Mayotte' },
  { value: 'Mexico', label: 'Mexico' },
  { value: 'Micronesia', label: 'Micronesia' },
  { value: 'Moldova', label: 'Moldova' },
  { value: 'Mongolia', label: 'Mongolia' },
  { value: 'Montenegro', label: 'Montenegro' },
  { value: 'Morocco', label: 'Morocco' },
  { value: 'Mozambique', label: 'Mozambique' },
  { value: 'Myanmar', label: 'Myanmar' },
  { value: 'Namibia', label: 'Namibia' },
  { value: 'Nepal', label: 'Nepal' },
  { value: 'Netherlands', label: 'Netherlands' },
  { value: 'Netherlands Antilles', label: 'Netherlands Antilles' },
  { value: 'New Caledonia', label: 'New Caledonia' },
  { value: 'New Zealand', label: 'New Zealand' },
  { value: 'Nicaragua', label: 'Nicaragua' },
  { value: 'Niger', label: 'Niger' },
  { value: 'Nigeria', label: 'Nigeria' },
  { value: 'North Korea', label: 'North Korea' },
  { value: 'North Macedonia', label: 'North Macedonia' },
  { value: 'Norway', label: 'Norway' },
  { value: 'Occupied Palestinian Territory', label: 'Occupied Palestinian Territory' },
  { value: 'Oman', label: 'Oman' },
  { value: 'Pakistan', label: 'Pakistan' },
  { value: 'Panama', label: 'Panama' },
  { value: 'Papua New Guinea', label: 'Papua New Guinea' },
  { value: 'Paraguay', label: 'Paraguay' },
  { value: 'Peru', label: 'Peru' },
  { value: 'Philippines', label: 'Philippines' },
  { value: 'Poland', label: 'Poland' },
  { value: 'Portugal', label: 'Portugal' },
  { value: 'Puerto Rico', label: 'Puerto Rico' },
  { value: 'Qatar', label: 'Qatar' },
  { value: 'Réunion', label: 'Réunion' },
  { value: 'Romania', label: 'Romania' },
  { value: 'Russia', label: 'Russia' },
  { value: 'Rwanda', label: 'Rwanda' },
  { value: 'Saint Lucia', label: 'Saint Lucia' },
  { value: 'Saint Vincent and the Grenadines', label: 'Saint Vincent and the Grenadines' },
  { value: 'Samoa', label: 'Samoa' },
  { value: 'Sao Tome and Principe', label: 'Sao Tome and Principe' },
  { value: 'Saudi Arabia', label: 'Saudi Arabia' },
  { value: 'Senegal', label: 'Senegal' },
  { value: 'Serbia', label: 'Serbia' },
  { value: 'Sierra Leone', label: 'Sierra Leone' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'Slovakia', label: 'Slovakia' },
  { value: 'Slovenia', label: 'Slovenia' },
  { value: 'Solomon Islands', label: 'Solomon Islands' },
  { value: 'Somalia', label: 'Somalia' },
  { value: 'South Africa', label: 'South Africa' },
  { value: 'South Korea', label: 'South Korea' },
  { value: 'South Sudan', label: 'South Sudan' },
  { value: 'Spain', label: 'Spain' },
  { value: 'Sri Lanka', label: 'Sri Lanka' },
  { value: 'Sudan', label: 'Sudan' },
  { value: 'Suriname', label: 'Suriname' },
  { value: 'Swaziland', label: 'Swaziland' },
  { value: 'Sweden', label: 'Sweden' },
  { value: 'Switzerland', label: 'Switzerland' },
  { value: 'Syrian Arab Republic', label: 'Syrian Arab Republic' },
  { value: 'Tajikistan', label: 'Tajikistan' },
  { value: 'Tanzania', label: 'Tanzania' },
  { value: 'Thailand', label: 'Thailand' },
  { value: 'Timor-Leste', label: 'Timor-Leste' },
  { value: 'Togo', label: 'Togo' },
  { value: 'Tonga', label: 'Tonga' },
  { value: 'Trinidad & Tobago', label: 'Trinidad & Tobago' },
  { value: 'Tunisia', label: 'Tunisia' },
  { value: 'Turkey', label: 'Turkey' },
  { value: 'Turkmenistan', label: 'Turkmenistan' },
  { value: 'U.S. Virgin Islands', label: 'U.S. Virgin Islands' },
  { value: 'Uganda', label: 'Uganda' },
  { value: 'Ukraine', label: 'Ukraine' },
  { value: 'United Arab Emirates', label: 'United Arab Emirates' },
  { value: 'United Kingdom', label: 'United Kingdom' },
  { value: 'United States', label: 'United States' },
  { value: 'Uruguay', label: 'Uruguay' },
  { value: 'Uzbekistan', label: 'Uzbekistan' },
  { value: 'Vanuatu', label: 'Vanuatu' },
  { value: 'Venezuela', label: 'Venezuela' },
  { value: 'Vietnam', label: 'Vietnam' },
  { value: 'Western Sahara', label: 'Western Sahara' },
  { value: 'Yemen', label: 'Yemen' },
  { value: 'Zambia', label: 'Zambia' },
  { value: 'Zimbabwe', label: 'Zimbabwe' }
]

export const ContactSource = {
  SSOT: 'people_ssot',
  Q4DESKTOP: 'q4desktop',
  Q4: 'q4'
}